import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import EfSection from '@elem/ui/ef-section';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';

let titleSceneC: any = null;
export default function UltraSavings() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.ECOMode');

    const data1 = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747211403335/Group%201321319807.png',
            title: t('box1_title'),
            subTitle: t('box1_subTitle'),
            desc: t('box1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747216176090/Group%201321319806.png',
            title: t('box2_title'),
            subTitle: t('box2_subTitle'),
            desc: t('box2_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747211435084/Group%201321319806%20(1).png',
            title: t('box3_title'),
            subTitle: t('box3_subTitle'),
            desc: t('box3_desc'),
        },
    ];
    return (
        <>
            <section className={`ECOMode-detail ECOMode-detail-section ${css['ECOMode-detail']}`} id="ECOMode-detail">
                <EfSpec />

                <EfSection
                    title={t.rich('secECOMode_title', {
                        w: (text: any) => <span className="sub">{text}</span>,
                    })}
                    desc={t('secECOMode_desc')}
                />
                <EcoSpaceSmall />
                <div className="ECOMode-top">
                    {data1.map((item, i) => {
                        return (
                            <div className="ECOMode-top-item" key={i}>
                                <div className="ECOMode-top-title">
                                    <div className="ECOMode-top-title-img">
                                        <EFPicture src={item.img} alt={item.title} />
                                    </div>
                                    <div className="ECOMode-top-title-text">{item.title}</div>
                                </div>
                                <p className="ECOMode-top-subTitle">{item.subTitle}</p>
                                {/* <p className="ECOMode-top-desc"></p> */}
                            </div>
                        );
                    })}
                </div>
                <div className="ECOMode-bottom">
                    <EFPicture
                        src={'https://websiteoss.ecoflow.com/upload/image/1747902067241/Frame%201612707523%20(1).jpg'}
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1747902071548/Frame%201612707570.jpg"
                    />
                </div>
                <div className="ECOMode-link" onClick={() => {}}>
                    <a href="https://us.ecoflow.com/products/powerpulse-ev-charger" target="_blank">
                        {t('secECOMode_link') + ' >'}
                    </a>
                </div>
            </section>
        </>
    );
}
